<template>
  <div>
    <template v-if="type == 'pinned'">
      <div class="w-100" v-if="isMembershipRewardApplied" :class="wrapper_class">
        <template v-if="title_type == 'outside'">
          <p class="body-1-4 mb-0">You are currently claiming this reward</p>
          <p class="body-3-3-1 mb-2">CLick the close button to cancel</p>
        </template>
        <div 
          class="w-100 border-semi-grey position-relative mb-3 radius-6" 
          :style="{backgroundImage: `url(${getMembershipRewardApplied.image_url})`,height: title_type == 'outside' ? '150px' : '170px'}"
          style="background-size: cover;background-position: center;">
          <div class="w-100 z-index-1027 py-4 pr-4 pl-5 position-relative">
            <div class="bg-white m-2 rounded-circle position-absolute border-semi-grey cursor-pointer" @click="resetSavedReward()" style="display:inline-flex;padding:8px; right:-3px;top:-3px;">
              <img alt="close-icon" src="../../../assets/img/icon/close.png" width="10" />
            </div>
            <p class="mb-0 text-white font-extrabold heading-4-1">{{ getMembershipRewardApplied.name }}</p>
            <p class="mb-4 text-white body-2">{{ getMembershipRewardApplied.sub_tagline }}</p>
            <div class="w-100" v-if="title_type == 'inside'">
              <p class="body-1-4 mb-0 text-grey">You are currently claiming this reward</p>
              <p class="body-3-3-1 mb-2 text-grey">CLick the close button to cancel</p>
            </div>
          </div>
          <div class="dark-overlay w-100 z-index-1026" :style="{height: title_type == 'outside' ? '150px' : '170px'}"></div>
          <div class="reward-item-dot" style="left: -15px;"></div>
          <div class="reward-item-dot" style="right: -15px;"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div 
        class="w-100 border-semi-grey position-relative mb-3 radius-6" 
        :style="{backgroundImage: `url(${data.image_url})`}"
        style="height: 220px;background-size: cover;background-position: center;">
        <div class="w-80 z-index-1027 p-4 position-relative cursor-pointer" @click="toggleRewarDetail()">
          <p class="mb-4 text-grey overline text-uppercase">{{ printModule(data) }}</p>
          <p class="mb-0 text-white font-extrabold heading-4-1">{{data.name}}</p>
          <p class="mb-4 text-white body-2">{{ data.sub_tagline }}</p>
          <div class="w-100 no-ws" v-if="$isNotEmpty(data.terms_and_conditions)">
            <i class="simple-icon-info d-inline-block align-middle mr-2 text-12 text-grey"></i>
            <p class="mb-0 text-grey body-3-3 d-inline-block align-middle">Terms & Conditions</p>
          </div>
        </div>
        <div class="dark-overlay w-100 z-index-1026" style="height: 220px;"></div>
        <div class="reward-item-dot" style="left: -15px;"></div>
        <div class="reward-item-dot" style="right: -15px;"></div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex';

  export default {
    props:{
      wrapper_class:{
        type: String,
        default: ''
      },
      type:{
        type: String,
        default: 'pinned'
      },
      title_type: {
        type: String,
        default: 'outside'
      },
      data:{
        type: Object,
        default: () => {}
      }
    },
    computed:{
      ...mapGetters(['isMembershipRewardApplied','getMembershipRewardApplied'])
    },
    methods:{
      ...mapMutations(['setMembershipRewardApplied']),
      resetSavedReward(){
        this.setMembershipRewardApplied({})
      },
      toggleRewarDetail(){
        this.$emit('detail',this.data)
      },
      printModule(data){
        let data_return = 'Room Booking'
        if(data.type == 'CONCIERGE_PROMOTION'){
          data_return = `${data.module[0].name}`
          if(data.module.length > 1){
            data_return += ' and more'
          }
        }
        return data_return
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/ClaimingReward.vue